import { Container, Typography, Button, Box } from "@mui/material";
import { Email } from "@mui/icons-material";

const Contact = () => {
  const email = "andrea.ricci94@gmail.com";

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        Contattami
      </Typography>

      <Typography variant="body1" color="text.secondary">
        Se vuoi metterti in contatto con me, puoi inviarmi un'email cliccando sul pulsante qui sotto.
      </Typography>

      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Email />}
          href={`mailto:${email}`}
        >
          Scrivimi un'email
        </Button>
      </Box>

      <Box mt={2}>
        <Typography variant="body2" color="text.secondary">
          Oppure invia un'email a{" "}
          <Typography component="span" color="primary" fontWeight="bold">
            {email}
          </Typography>
        </Typography>
      </Box>
    </Container>
  );
};

export default Contact;
